@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container six-pack-container" [ngClass]="tupleClass">
    <div class="option-group-header">
        @for (header of optionHeaders | keyvalue: keepOrder; track header) {
            <span class="six-pack-col">{{ header.value }}</span>
        }
    </div>
    @for (optionRow of optionRows; track trackByPlayer($index, optionRow)) {
        @for (column of optionRow.columns | keyvalue: keepOrder; track trackByCol($index, column)) {
            @if (isOption(column.value)) {
                <ms-bet-builder-option
                    [tracking]="{ source: tracking }"
                    [option]="column.value"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [sourceOfPick]="sourceOfPick" />
            } @else {
                <div class="option">
                    <span class="empty-option">-</span>
                </div>
            }
        }
    }
</div>
